import { Modal, Button } from "react-bootstrap";
import { ILogistics } from '@nkr/models/index';
import LogisticsViewContent from "./view-content";

interface IProps {
    show: boolean;
    data: ILogistics,
    fontSize?: number,
    onClose: () => void;
}

const LogisticsView = (props: IProps) => {
    if (props.data == null)
        return null;

    return (
        <Modal dialogClassName="logistics-view" show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Swap Logistics</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <LogisticsViewContent
                    data={props.data}
                    fontSize={props.fontSize ? props.fontSize : 12}
                />
            </Modal.Body>

            <Modal.Footer>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div></div>
                    <div style={{ display: "flex" }}>
                        <Button bsStyle="primary" onClick={props.onClose}>Close</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default LogisticsView;